import React from 'react';
import { Card, Typography } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import JoinProjectAsSubscriberAdminButton from '../project-users/JoinProjectAsSubscriberAdminButton';

export default function SubscriberAdminJoinProjectCard() {
  return (
    <Card style={{ height: '100%' }}>
      <CardContent
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6" style={{ fontSize: 17 }}>
          You are a subscriber admin
        </Typography>
        <JoinProjectAsSubscriberAdminButton />
      </CardContent>
    </Card>
  );
}
